export type RawEventAttributes =
	| Record<string, number | string>
	| null
	| undefined;

export function pickAttributeValue(
	attributes: RawEventAttributes,
	keys: readonly string[]
): number | string | undefined {
	if (!attributes) {
		return;
	}
	for (const key of keys) {
		if (key in attributes) {
			const v = attributes[key];
			if (v !== undefined && v !== null && v !== "") {
				return v;
			}
		}
	}
	return;
}

export function pickAttributeText(
	attributes: RawEventAttributes,
	keys: readonly string[]
): string {
	const raw = pickAttributeValue(attributes, keys);
	if (raw === undefined || raw === null) {
		return "";
	}
	if (typeof raw === "number") {
		return Number.isNaN(raw) ? "" : String(raw);
	}
	return raw.trim();
}
